export enum MDSLoadingIconSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export interface MDSLoadingIconProps {
  /** Size of the loading dots animation */
  size?: MDSLoadingIconSize;
  /** Optional class name for additional styling */
  className?: string;
  /** Whether the animation should loop continuously */
  loop?: boolean;
  /** Animation speed multiplier (1.0 is normal speed) */
  speed?: number;
}
